import { $$ } from 'utils/dom';

function createObserver() {
  // let observer;

  const options = {
    root: null,
    rootMargin: '20% 0% -90% 0%',
    threshold: buildThresholdList(),
  };

  const observer = new IntersectionObserver(handleIntersect, options);

  audioElements.forEach(audioElement => {
    observer.observe(audioElement);
  });
}

function buildThresholdList() {
  const thresholds = [];
  const numSteps = 20;

  for (let i = 1.0; i <= numSteps; i++) {
    const ratio = i / numSteps;
    thresholds.push(ratio);
  }
  return thresholds;
}

function handleIntersect(entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
    } else {
      entry.target.classList.remove('visible');
    }
  });
}

const audioElements = $$('.landingpage-audio');

if (audioElements.length) {
  createObserver();
}
